var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Carousel',{attrs:{"loop":"","height":380,"arrow":"never","dots":"none"}},[_c('CarouselItem',[_c('div',{staticClass:"banner"},[_c('div',[_c('p',{staticClass:"pageType"},[_vm._v("个人中心")])])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }